// Инструкции для вкладок раздела «Склад» (кнопка «?» в правом углу строки вкладок).
// Формат: { title, intro, sections: [{ heading, items: [[название, пояснение], ...] | text }] }.

const OWN_WAREHOUSE_HELP = {
    returns: {
        title: "Возвраты по ТТН",
        intro: "Приёмка годных товаров на исходный собственный склад. Введите исходную ТТН или от четырёх её цифр и выберите отправление.",
        sections: [{ heading: "Порядок действий", items: [
            ["Создать черновик", "Сохраняет исходные реквизиты заказа и товары. Остатки не меняются."],
            ["Принято", "Укажите фактически полученное годное количество. Ноль исключает строку из проведения."],
            ["Сохранить → Провести", "Проверьте рассчитанную сумму. Списанный товар вернётся в партии с исходной себестоимостью; для несписанного товара снимется только резерв."],
            ["Нужна сверка", "Нет исходного резерва, он уже снят или история старого возврата неоднозначна. Такую строку проводить нельзя."],
            ["Проведённый документ", "Доступен для просмотра; изменение и отмена проведения не поддерживаются."],
        ] }],
    },
    registry: {
        title: "Склады",
        intro: "Здесь заводятся собственные склады и меняются их настройки. Один склад — это одновременно отправитель заказов (код вида D19) и одно юрлицо. Всё, что лежит на складе, продаётся от имени этого юрлица.",
        sections: [
            {
                heading: "Таблица складов",
                items: [
                    ["Строка склада", "Нажмите на строку, чтобы открыть карточку склада и сделать его текущим для остальных вкладок."],
                    ["SKU в наличии, остаток, резерв", "Сколько товаров есть на складе, сколько штук всего и сколько отложено под заказы."],
                    ["Стоимость", "Сколько стоит весь товар на складе по себестоимости (по партиям)."],
                ],
            },
            {
                heading: "Карточка склада → «Профиль»",
                items: [
                    ["Название, адрес, заметки", "Для людей: как склад будет называться в админке и в карточках SalesDrive."],
                    ["Юрлицо", "От имени какого юрлица отгружается товар. Меняется только при создании склада."],
                    ["Точка отправки Новой Почты", "Отделение или адрес, откуда склад отправляет посылки. С этой точки создаются ТТН."],
                    ["Склад активен", "Выключите, чтобы склад полностью перестал работать: офферы удалятся, заказы на него не пойдут."],
                    ["Остатки публикуются (офферы)", "Включено — товары склада появляются в остатках магазинов и на маркетплейсах."],
                    ["Участвует в заказах", "Включено — склад можно выбрать поставщиком заказа, под заказ ставится резерв, процессор создаёт ТТН."],
                    ["Наценка по умолчанию, %", "Подставляется в новые накладные и в переоценку, если наценку не указали явно."],
                    ["Округление цены", "Как округлять базовую цену: без округления, до целых гривен или до 50 копеек вверх."],
                    ["Публиковать офферы с нулевым остатком", "Если товар закончился, он остаётся в выгрузке маркетплейсов как «нет в наличии» (для Tabletki нулевые остатки не уходят)."],
                    ["Приоритет отправителя", "Число от 1 до 10. Решает, кто побеждает, если у нескольких отправителей одинаковая цена."],
                    ["Ярус публикации (tier)", "Сильнее цены: отправитель с большим ярусом побеждает даже при более высокой цене. У складов обычно 1, у поставщиков 0. Работает, если в настройках Business включён «Ярус приоритета отправителей»."],
                    ["ID поставщика в SalesDrive", "Номер этого склада в списке поставщиков SalesDrive (поле supplierlist). Без него заказы склада не будут обрабатываться автоматически."],
                    ["Город отправки", "Город, который пишется в карточку SalesDrive."],
                    ["Отправитель активен", "Выключение отправителя тоже удаляет офферы склада."],
                    ["Сбросить / Сохранить", "Отменить несохранённые изменения или записать их."],
                ],
            },
            {
                heading: "Карточка склада → «Создание»",
                items: [
                    ["Юрлицо", "Выберите юрлицо — ниже появится проверка: найдено ли юрлицо, не занято ли другим складом, есть ли настройки и точки Новой Почты."],
                    ["Код склада", "Подставляется сам (следующий свободный в ряду D). Менять не нужно."],
                    ["Магазины Tabletki", "В каких магазинах будут видны товары склада. Ничего не выбрано — все активные магазины."],
                    ["Цена как РРЦ в магазинах", "Включено — в магазинах продаётся ровно по базовой цене склада. Выключено — цена считается от себестоимости по общим правилам наценки."],
                    ["Маркетплейсы", "Для отмеченных аккаунтов Prom/Rozetka/Kasta склад будет добавлен в настройки (выключенным — включите его потом в настройках площадки)."],
                    ["Создать склад", "Создаёт склад, отправителя, связи с магазинами и настройки площадок одним действием."],
                ],
            },
        ],
    },
    stock: {
        title: "Остатки и партии",
        intro: "Что лежит на выбранном складе прямо сейчас. Каждый приход — это отдельная партия со своей себестоимостью. Продажа списывает сначала самые старые партии (FIFO).",
        sections: [
            {
                heading: "Поиск и кнопки",
                items: [
                    ["Поиск (SKU или название)", "Начало кода товара или часть названия. Нажмите «Найти»."],
                    ["Только с остатком", "Скрыть товары, которых сейчас нет на складе."],
                    ["Скачать Excel", "Выгрузить остатки выбранного склада с текущими фильтрами. В колонке «Фактическое наличие» можно вручную записать результат пересчёта."],
                    ["Корректировка ±", "Ручное изменение остатка (инвентаризация, бой, брак, просрочка)."],
                    ["Переоценить выбранные", "Отметьте товары галочками и нажмите — откроется вкладка «Цены / переоценка» с этими товарами."],
                    ["Выбрать все", "Отметить все товары на странице."],
                    ["Назад / Вперёд", "Листать страницы списка."],
                ],
            },
            {
                heading: "Колонки",
                items: [
                    ["Остаток", "Сколько штук физически на складе."],
                    ["Резерв", "Сколько отложено под заказы, которые ещё не уехали."],
                    ["Доступно", "Остаток минус резерв — столько можно продать прямо сейчас. Именно это число уходит в выгрузку."],
                    ["С/с FIFO", "Себестоимость самой старой партии — по ней спишется следующая продажа."],
                    ["С/с средняя", "Средняя себестоимость всего, что лежит на складе."],
                    ["Базовая цена и источник", "Розничная цена склада и откуда она взялась: из накладной (вручную или наценкой) или из переоценки. Товар без базовой цены не публикуется."],
                    ["Партии", "Нажмите на строку товара — раскроется список партий: когда пришла, сколько было и осталось, себестоимость с НДС и без, срок годности, поставщик, накладная, статус (открыта / закрыта / аннулирована)."],
                ],
            },
            {
                heading: "Корректировка остатка ±",
                items: [
                    ["SKU", "Код товара в нашем каталоге."],
                    ["Количество (±)", "Плюс — добавить на склад, минус — списать. Минус не может быть больше доступного остатка."],
                    ["Причина", "Инвентаризация, бой, брак, срок годности или другое — видно потом в «Движениях»."],
                    ["Себестоимость", "Нужна только для «плюса»: по ней создаётся новая партия."],
                    ["Срок годности, комментарий", "Необязательно. Срок попадёт в новую партию."],
                    ["Провести корректировку", "Изменить остаток. Списание идёт по FIFO с самых старых партий."],
                ],
            },
        ],
    },
    movements: {
        title: "Движения",
        intro: "Журнал всего, что происходило с остатками склада: приходы, резервы под заказы, отгрузки, возвраты, корректировки. Журнал нельзя править — только читать.",
        sections: [
            {
                heading: "Фильтры",
                items: [
                    ["SKU", "Показать движения одного товара."],
                    ["Тип события", "Приход по накладной, отмена проведения, корректировка, возврат, резерв, снятие резерва, списание по заказу."],
                    ["С даты / По дату", "Период (по киевскому времени)."],
                    ["Заказ (order_ref)", "Номер заказа — покажет резерв и списание по нему."],
                    ["Сбросить фильтры", "Вернуть полный журнал."],
                ],
            },
            {
                heading: "Колонки",
                items: [
                    ["Δ остаток", "На сколько изменился физический остаток (+ приход, − расход)."],
                    ["Δ резерв", "На сколько изменился резерв (+ поставлен, − снят или списан)."],
                    ["С/с", "Себестоимость единицы в этом движении."],
                    ["Партия, заказ, причина, кто", "Откуда списали/куда пришло, по какому заказу, почему и кем."],
                ],
            },
            {
                heading: "Возвраты",
                items: [["Вкладка «Возвраты»", "Создайте документ по исходной ТТН, сохраните фактически принятое количество и проведите его. Результат будет виден в журнале движений."]],
            },
            {
                heading: "Резервы",
                items: [
                    ["Статус", "Активные — ещё ждут отправки; снятые — заказ отменён; списанные — заказ уехал; истекшие — карточка заказа так и не появилась."],
                    ["Канал, заказ, карточка SalesDrive", "Откуда пришёл заказ (Tabletki, Prom, Rozetka, Kasta, вручную) и к какой карточке привязан резерв."],
                    ["Себестоимость", "Оценка при резерве и фактическая себестоимость после списания."],
                ],
            },
        ],
    },
    invoices: {
        title: "Накладные",
        intro: "Приход товара на склад. Накладную можно загрузить файлом поставщика или заполнить вручную. Товар появляется на складе только после кнопки «Провести».",
        sections: [
            {
                heading: "Реестр накладных",
                items: [
                    ["Новая накладная", "Открыть форму создания."],
                    ["Строка накладной", "Открыть накладную. Колонка «Проведена» показывает, оприходован ли уже товар."],
                    ["Обновить", "Перечитать список."],
                ],
            },
            {
                heading: "Новая накладная",
                items: [
                    ["Поставщик", "У кого купили товар (оптовый поставщик)."],
                    ["Номер, дата", "Номер и дата документа поставщика."],
                    ["Ожидаемая дата поставки", "Необязательно. Если указана — партия получит эту дату прихода."],
                    ["НДС, ставка НДС", "С НДС или без. Себестоимость партии хранится с НДС."],
                    ["Розничная цена / % наценки", "Как получить базовую цену: % наценки к себестоимости для всех строк или вручную по каждой строке."],
                    ["Создать накладную", "Создать документ, после этого можно добавлять строки."],
                ],
            },
            {
                heading: "Внутри накладной",
                items: [
                    ["Загрузить файлы / Распарсить файл", "Загрузить файл поставщика и разобрать его в строки. Повторный разбор заменяет строки."],
                    ["Добавить позицию", "Найти товар по названию или SKU и добавить строку вручную."],
                    ["Наш SKU", "С каким товаром нашего каталога сопоставлена строка. Без сопоставления провести нельзя."],
                    ["Qty, Cost без НДС", "Количество (целое, в штуках) и цена закупки за единицу."],
                    ["Розница", "Ручная розничная цена строки. Пусто — цена считается по % наценки накладной."],
                    ["Синхронизировать внешние коды", "Завести коды товаров для Tabletki, если их ещё нет."],
                    ["Сохранить, Копия, Удалить", "Записать изменения, сделать копию документа, удалить (нельзя после проведения)."],
                ],
            },
            {
                heading: "Проведение",
                items: [
                    ["Предпросмотр проведения", "Показывает, что попадёт на склад: количество, себестоимость, базовую цену и предупреждения («нет цены», «нет сопоставления», «дробное количество»)."],
                    ["Провести", "Оприходовать товар: по каждой строке создаётся партия, обновляются остаток и базовая цена, товар уходит в выгрузку. Повторное нажатие ничего не задвоит."],
                    ["Отменить проведение", "Возможно, только пока из этой накладной ничего не продано и не зарезервировано. Иначе оформите корректировку на вкладке «Остатки»."],
                    ["Проведённая накладная", "Строки, сопоставление и файлы в ней больше не редактируются."],
                ],
            },
        ],
    },
    pricing: {
        title: "Цены / переоценка",
        intro: "Изменение базовой розничной цены склада сразу для одного или многих товаров. Базовая цена — это цена, по которой склад предлагает товар магазинам и маркетплейсам.",
        sections: [
            {
                heading: "Позиции",
                items: [
                    ["Добавить SKU", "Введите коды через запятую или пробел и нажмите «Добавить». Ничего не добавлено — переоцениваются все товары с остатком."],
                    ["Очистить", "Убрать выбранные товары."],
                ],
            },
            {
                heading: "Правило",
                items: [
                    ["Режим", "% к себестоимости FIFO (ближайшей партии), % к средней себестоимости, % к себестоимости последнего прихода или цена вручную по каждому SKU."],
                    ["Наценка, %", "Например, 50 — цена будет себестоимость × 1,5. Пусто — берётся наценка склада по умолчанию."],
                    ["Округление", "Без округления, до целых или до 50 копеек вверх."],
                    ["Комментарий", "Зачем делали переоценку — сохранится в истории."],
                    ["Предпросмотр", "Показывает старую и новую цену и изменение в % — ещё ничего не меняет."],
                    ["Применить", "Записать новые цены. Если с момента предпросмотра остатки или цены изменились, система попросит обновить предпросмотр."],
                ],
            },
            {
                heading: "История и проверка публикации",
                items: [
                    ["История переоценок", "Кто, когда и каким правилом менял цены."],
                    ["Dry-run офферов", "Показывает, какие предложения склад отдаст в каждый магазин и по какой цене, ничего не записывая."],
                    ["Пересобрать офферы", "Сразу обновить предложения склада в магазинах (иначе это сделает планировщик в течение нескольких минут)."],
                ],
            },
        ],
    },
    dynamics: {
        title: "Динамика",
        intro: "Как менялся склад по дням: остаток в штуках и деньгах, приходы, отгрузки, возвраты. Плюс что продаётся медленно и у чего скоро истекает срок.",
        sections: [
            {
                heading: "Период и графики",
                items: [
                    ["С / По", "Период для графиков (по умолчанию последние 30 дней)."],
                    ["Пересчитать за период", "Пересобрать суточные цифры из журнала движений (нужно, если данные за дни отсутствуют). Безопасно повторять."],
                    ["Графики остатка", "Сколько было на складе в конце каждого дня — в штуках и по себестоимости."],
                    ["Приходы / отгрузки / возвраты", "Столбики по дням: сколько пришло, сколько уехало по заказам, сколько вернулось."],
                ],
            },
            {
                heading: "Оборачиваемость",
                items: [
                    ["Окно", "За сколько последних дней считать продажи (7, 30, 90)."],
                    ["Дней запаса", "На сколько дней хватит текущего остатка при таком темпе продаж. Пусто — за период не было продаж."],
                ],
            },
            {
                heading: "Истекающие партии",
                items: [
                    ["Горизонт", "Показать партии, у которых срок годности заканчивается в ближайшие 30, 90 или 180 дней."],
                    ["Осталось дней", "Жёлтым — меньше 30 дней. Такие товары стоит продать в первую очередь или переоценить."],
                ],
            },
        ],
    },
    settings: {
        title: "Настройки",
        intro: "Общие выключатели контура «Склад» для всех складов. Изменения действуют без перезапуска сервера, примерно через минуту.",
        sections: [
            {
                heading: "Переключатели (включать по порядку сверху вниз)",
                items: [
                    ["Контур включён", "Главный выключатель. Выключен — проведение, корректировки, возвраты и переоценка заблокированы, склады ни на что не влияют."],
                    ["Публиковать офферы складов", "Товары складов попадают в остатки магазинов Tabletki и маркетплейсов."],
                    ["Публикация в режиме dry-run", "Пробный режим: офферы только считаются и пишутся в лог. Снимите галочку, когда проверите результат на вкладке «Цены»."],
                    ["Участие в заказах", "Склад можно выбирать поставщиком заказа: ставится резерв, процессор создаёт ТТН."],
                    ["Предпочитать склад при выборе", "Если товар есть на складе — заказ идёт со склада, даже если у поставщика дешевле."],
                    ["Заказы в режиме dry-run", "Пробный режим заказов: резервы, ТТН и списания не создаются, только пишутся в лог."],
                    ["Реакция на статусы SalesDrive", "Списывать товар, когда заказ уехал, и снимать резерв, когда заказ отменили."],
                    ["Списание после снятия резерва", "Что делать, если заказ уехал, а резерв уже сняли: issue — сообщить в Telegram и ничего не списывать; write_off_unreserved — списать остаток без резерва."],
                ],
            },
            {
                heading: "Политика статусов SalesDrive",
                items: [
                    ["Списать со склада", "Номера статусов, при которых товар считается уехавшим (по умолчанию 11 «В дороге НП» и 12 «Прибыл НП»)."],
                    ["Снять резерв", "Статусы отмены (по умолчанию 6 «Отказ», 17 «Свой отказ», 8 «Удален») — товар снова доступен к продаже."],
                    ["Ничего не делать", "Статусы, на которые склад не реагирует (по умолчанию 14 «Отказ НП»)."],
                    ["Возврат — ручной", "Статус возврата (по умолчанию 7): склад только напомнит оформить возврат на вкладке «Движения»."],
                ],
            },
            {
                heading: "Статусы и сроки",
                items: [
                    ["Статус карточки после ТТН", "В какой статус SalesDrive переводить заказ после создания ТТН (по умолчанию 21 «На отправку»). В Tabletki при этом сразу уходит статус 4 и ТТН."],
                    ["Статус при нехватке остатка", "Куда перевести карточку, если товара на складе не хватило. Пусто — карточка остаётся в статусе 1 для ручной обработки."],
                    ["TTL резерва, часов", "Через сколько часов снять резерв, если карточка заказа в SalesDrive так и не появилась."],
                    ["Отменить изменения / Сохранить", "Вернуть значения из базы или записать новые."],
                ],
            },
        ],
    },
};

export default OWN_WAREHOUSE_HELP;
